import React, { forwardRef } from "react";

type TButtonProps = React.ComponentPropsWithoutRef<"span"> & {
  text?: string;
  icon?: JSX.Element | React.ReactNode;
};

const ButtonDummy = forwardRef<HTMLButtonElement, TButtonProps>(
  ({ text, icon, className, ...rest }, ref) => {
    return (
      <span
        ref={ref}
        {...rest}
        className={`text-sm text-body select-none font-semibold flex items-center justify-center gap-1 ${className}`}
      >
        <div className="flex items-center gap-2">
          {text && <span>{text}</span>}
          {icon}
        </div>
      </span>
    );
  }
);

ButtonDummy.displayName = "ButtonDummy";

export default ButtonDummy;
